<div class="modal-header">
  <button class="btn note-btn button_green d-lg-flex" (click)="saveNote()">
    <img src="../../assets/icons/buttons/save-white.svg" alt="">
    <span>Ok</span>
  </button>
  <button class="btn note-btn button_red d-lg-flex" (click)="cancelNote()">
    <img src="../../assets/icons/buttons/x-icon-white.png" alt="">
    <span>Cancel</span>
  </button>
</div>
<div class="modal-body">
  <textarea class="note-textarea" [(ngModel)]="noteText"></textarea>
</div>